import React from 'react';
import { makeStyles, Typography, Button } from '~/lib/bn-material-ui';

const useStyles = makeStyles(theme => ({
  container: {
    position: 'absolute',
    top: theme.spacing(2),
    left: theme.spacing(2),
    zIndex: 1000,
    backgroundColor: theme.palette.gray[60],
    borderRadius: theme.shape.borderRadius,
    border: 'none',
    minWidth: '4rem',
    userSelect: 'none',
    textAlign: 'center',
    // Remove default button styling
    '&.MuiButton-root': {
      textTransform: 'none',
      boxShadow: 'none',
      padding: theme.spacing(0.5, 1),
      minHeight: 'auto',
      '&:hover': {
        backgroundColor: theme.palette.gray[70],
        boxShadow: 'none',
      },
      '&:active': {
        backgroundColor: theme.palette.gray[80],
        boxShadow: 'none',
      },
    },
  },
  zoomValue: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: theme.palette.white,
  },
}));

/**
 * Component for displaying current zoom level and resetting zoom on the inventory map
 * @param {Object} props - Component props
 * @param {number} props.zoomPercentage - Current zoom percentage (0-100)
 * @param {Function} props.onClick - Callback when zoom control is clicked
 * @returns {JSX.Element} Zoom control component
 */
export default function InventoryMapZoomControl({
  zoomPercentage = 0,
  onClick,
}) {
  const styles = useStyles();

  return (
    <Button
      className={styles.container}
      onClick={onClick}
      disableRipple
    >
      <Typography className={styles.zoomValue}>
        {Math.round(zoomPercentage)}%
      </Typography>
    </Button>
  );
}
